import React from "react";
import "./styles.css";
import { Table } from "react-bootstrap";
import { formatDateTime } from "../../../utils/stringFunctions";

interface IntentionsByRequestorPrintoutProps {
  report: {
    printDateTime?: string;
    intentions: {
      requestor: string;
      subject: string;
      startDateTime: string;
    }[];
  };
}

export class IntentionsByRequestorPrintout extends React.PureComponent<IntentionsByRequestorPrintoutProps> {
  render() {
    const { report } = this.props;
    return (
      <div className="intentions-by-presider-print-report-container">
        <h2>Report Date & Time</h2>
        <h3>{report.printDateTime}</h3>
        <hr />
        <div className="intentions-by-presider-print-table-container">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Requestor</th>
                <th>Intention</th>
                <th>{`Mass Date & Time`}</th>
              </tr>
            </thead>
            <tbody>
              {report.intentions.map((i) => (
                <tr>
                  <td>{i.requestor}</td>
                  <td>{i.subject}</td>
                  <td>{formatDateTime(i.startDateTime)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}
